/**
 * Valor do timer usado para fazer o
 * balanceamento do do disparo do
 * evento de keyup
 *
 * @type {Number}
 */
let keyupTimer = 0;

/**
 * Formatar o valor da taxa para exibir na input, este método
 * substitui . por , e remove caracteres que não são numéricos
 *
 * @param {string} value
 */
function formatExchangeRate(value) {
  const numberFormatted = value.replace(/(\.)/g, ',');
  return  numberFormatted.replace(/[^\d\,]/g, '');
}

/**
 * Formata um número instring em float
 *
 * @param {string} stringNumber
 */
function stringToFloat(stringNumber, decimalSeparator = ',') {
  const arrayNumber = stringNumber.split(decimalSeparator);
  const number = parseInt(stringNumber.replace(/(\.|\,)/g, ''));

  // Se não tivermos casas decimais após o separador de decimal,
  // retorna o número já como float
  if (arrayNumber[1] === undefined) {
    return parseFloat(number);
  }

  // Montando o número que será usado na divisão para
  // para fazer a formatação do float, são acrescentado 0
  // para cada casa decimal que o número possui
  const lengthDecimalPlaces = arrayNumber[1].length;
  let divisor = 1;
  for (let index = 0; index < lengthDecimalPlaces; index++) {
    divisor = divisor + '0';
  }

  return (number / parseInt(divisor));
}

/**
 * Este método irá realizar o cálculo do câmbio aplicando a operação que for
 * necessária de acordo com o argumento recebido na função, por padrão o JS
 * está usando uma precisão de 4 casas decimais.
 * O valor arredondao pode ser fixado em uma determinada quantidade de casas decimais
 * de acordo com o informado como parâmetro no método
 *
 * @param {Number} valueInputExchange (o valor da input do cálculo [taxa|valor convertido])
 * @param {Number} expenseValue (valor da despesa)
 * @param {string} operator (operação [*|/])
 * @param {int} decimalPlaces (cadas decimais para fixar)
 */
function calculate(valueInputExchange, expenseValue, operator, decimalPlaces = 4) {
  let value;
  let absValue;

  // valor de precisão para determinar quantas casas decimais teremos no final
  const precision = Math.pow(10, 8);

  // Determiando os valores usados no cálculo com a presição definida anteriormente
  valueInputExchange *= precision;
  expenseValue *= precision;

  if (operator === '/') {
    value = valueInputExchange / expenseValue;
    absValue = Math.abs(Math.round(value * precision));
    return (absValue / precision).toFixed(decimalPlaces);
  }

  value = expenseValue * valueInputExchange;
  absValue = Math.abs(Math.round(value / precision));
  return (absValue / precision).toFixed(decimalPlaces);
}

/**
 * Realiza o balanceamento de término
 * do evento para apenas então disparar
 * o evento
 *
 * @param  {event}   event
 * @param  {callback} callback
 */
function keyupEvent(event, callback) {
  clearTimeout(keyupTimer);
  keyupTimer = setTimeout(function() {
    callback(event);
  }, 300);
}

/**
 * Verifica se a tecla digitada é uma tecla
 * numérica ou a tecla backspace
 *
 * @param  {event} event
 *
 * @return {boolena}
 */
function validKeyPress(event) {
  return event.which == 8
    || (event.keyCode >= 48 && event.keyCode <= 57)
    || (event.keyCode >= 96 && event.keyCode <= 105);
}

module.exports = {
  formatExchangeRate: formatExchangeRate,
  stringToFloat: stringToFloat,
  calculate: calculate,
  keyupEvent: keyupEvent,
  validKeyPress: validKeyPress,
};
